<template>
  <div>
    <form id='queryForm'>
      <div class='row h-row-inputBox'>
        <div class='col-sm-6 h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Software.MD5Code')}}:</div>
          <ejs-textbox name='md5Input'   v-model='OperatorInfo.md5Code'></ejs-textbox>
        </div>
        <div class='col-sm-6 h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Software.uploaderStr')}}:</div>
          <ejs-textbox  name='uploader'  v-model='OperatorInfo.uploaderStr'></ejs-textbox>
        </div>
        <div class='col-sm-6 h-col-inputBox' style='margin-top: 20px'>
          <div class='h-inputLit'>{{$t('Software.ExecuteFile')}}:</div>
          <ejs-uploader  ref='mcsfileRef' name="mcsfileName" id='mcsfile' :autoUpload= 'false' :selected= "onFileSelect"
            allowedExtensions= ".zip"  :multiple= 'false'  :success='success' maxFileSize=1048576000></ejs-uploader>
        </div>
      </div>

      <div class="h-borderBox" style="height:280px;margin-top: 20px">
        <div id="mcsUpdateTree" class="h-borderBox-top" style="height: 40px; background-color: #e6f7ff;">
          <div style="padding-top: 15px;padding-left:5px">{{$t('TS.ts_neList')}}</div>
        </div>
        <NeList ref='mcsNeList' :neArr='neType' :select='getNe'></NeList>
      </div>
    </form>
  </div>
</template>

<script>
import NeList from '../../components/common/NeList';
import TopoTree from '../topoconfig/TopoTree';
import Vue from "vue";
import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
import { FormValidator  } from '@syncfusion/ej2-inputs';
import { DialogPlugin  } from '@syncfusion/ej2-vue-popups';
import { EventBus } from '../../plugins/eventBus'
Vue.use(DialogPlugin);


export default {
    name: 'McsQuery',
    components: {
        TopoTree,
        NeList
    },
    inject: ['neType'],
    data() {
      return{
        OperatorInfo: {
          md5Code: '',
          uploaderStr: '',
        },
        fileNameString: "",
        path:  {
            saveUrl: 'https://aspnetmvc.syncfusion.com/services/api/uploadbox/Save',
            //removeUrl: 'https://aspnetmvc.syncfusion.com/services/api/uploadbox/Remove'
        },
        node:[],
        formObj: null,
        tipMessage: "",
        tipDialog: {
          element: {
            target: "#app",
            isClose: true,
            refName: "tip",
            buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t('System.cancel')}`, isPrimary: true }
            }
          ],
          title: `${this.$t('System.cancel')}`
        },
        uploadFileId:'',
        neId: '',
        styles: {
          width: "810px",
          height: "auto",
          model: true,
          visible: false
        }
      },
     validationOption: {
        customPlacement(inputElement, errorElement) {
          errorElement.style.position = 'fixed';
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
          md5Input: {
            required: [true, `${this.$t('Alarm.fieldIsRequired')}`],
            minLength: [32, `${this.$t('Software.RequiredLength')} 32`],
            maxLength: [32, `${this.$t('Software.RequiredLength')} 32`],
            regex: [/^[^'\\"<>%&]+$/, `${this.$t('Alarm.notInput')} ' " \\ < > % &`]
          },
          uploader: {
            required: [true, `${this.$t('Alarm.fieldIsRequired')}`],
            maxLength: [250, `${this.$t('Alarm.maxLength')}250`],
            regex: [/^[^'\\"<>%&]+$/, `${this.$t('Alarm.notInput')} ' " \\ < > % &`]
          },

        }
      }
    };
  },
  methods:{
    clearData() {
      this.OperatorInfo ={
        md5Code: '',
        uploaderStr: ''
      };
      this.$refs.mcsTree.uncheckAll();
    },
    onFileSelect(args) {
      let inputElement = document.getElementById("mcsfile").files[0];
      console.log("MCSQuery onFileSelect", inputElement);
    },
    success() {
    },
    getNe() {
      this.neId = this.$refs.mcsNeList.getNe().data.id;
      console.log("MCSTree getNe this.neId ",this.neId );
    },
    getMcsQueryData() {
      if(!this.validate()) {
        //EventBus.$emit('toast', {type: 'warning', content: this.$t('Software.validateInputInfo')});
        return undefined;
      }
      this.uploadFileId = 'mcsfile';
      console.log("MCS getMcsQueryData uploadFile ID", this.uploadFileId);
      return {
        md5Code: this.OperatorInfo.md5Code,
        person:this.OperatorInfo.uploaderStr,
        mpttFileId: this.uploadFileId,
        neid: this.neId,
        systemId: 1
      };
    },
    bindValidate() {
      this.formObj = new FormValidator('#queryForm', this.validationOption);
    },
    validate() {
      const formStatus = this.formObj.validate();
      return formStatus;
    }
  },
  mounted() {
    this.bindValidate();
  }
}
</script>>
